.e7{padding:0.5rem;}